import { Link } from "react-router-dom";
import { news } from "@/mocks/news";
import { FeaturedCard, ListRow } from "@/components/feature/NewsCard";
import { siteSlogan } from "@/hooks/useSeo";

export function Ticker() {
  const tickerItems = [...news].sort((a, b) => b.reads - a.reads).slice(0, 7);
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div className="w-full overflow-hidden border-b border-background-200 bg-foreground-950">
      <div className="mx-auto flex max-w-[1200px] items-stretch">
        <div className="z-10 flex shrink-0 items-center gap-1.5 bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 md:px-5">
          <i className="ri-broadcast-line animate-pulse"></i>
          <span className="whitespace-nowrap">今日热议</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2">
          <div className="animate-ticker flex w-max items-center gap-8 px-4 whitespace-nowrap">
            {doubled.map((n, i) => (
              <Link
                key={i}
                to={`/news/${n.id}`}
                className="flex items-center gap-2 text-xs text-background-100/85 transition-colors hover:text-accent-300"
              >
                <i className="ri-flashlight-line text-accent-400"></i>
                <span className="font-medium">{n.title}</span>
                <span className="text-background-100/50">{n.reads} 热议</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function HeroZone() {
  const featured = news.filter((n) => n.featured);
  const primary = featured[0] ?? news[0];
  const secondary = news.filter((n) => n.id !== primary.id).slice(0, 4);

  return (
    <section className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-4 py-8 md:px-6 lg:grid-cols-3">
      <div className="lg:col-span-2">
        <div className="mb-5">
          <span className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
            DAILY GOSSIP · 每日新瓜
          </span>
          <h1 className="font-display mt-2 text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
            扒开新面孔的隐藏故事，<br className="hidden md:block" />
            看清<span className="text-primary-600">人设背后的真相</span>
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600">
            {siteSlogan} 专注新晋网红黑料、小艺人黑历史、练习生爆料、新人演员翻车与素人走红黑幕，第一时间为你拆解娱乐场上的新瓜。
          </p>
        </div>
        <FeaturedCard item={primary} />
      </div>
      <aside className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-lg font-bold text-foreground-950">
            焦点速递
            <span className="ml-2 text-xs font-normal text-foreground-400">Focus</span>
          </h2>
          <Link to="/channels" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">
            全部 →
          </Link>
        </div>
        <div className="grid gap-4">
          {secondary.map((n, i) => (
            <ListRow key={n.id} item={n} index={i} />
          ))}
        </div>
      </aside>
    </section>
  );
}